<template>
  <v-footer
    color="black"
    dark
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
      <a v-for="link in links" :key="link.text" class="ma-4" color="white" :href="link.link">{{ link.text }}</a>
      <v-col
        class="black py-4 text-center white--text"
        cols="12"
      >
      <span class="font-weight-light">{{ new Date().getFullYear() }} — Meisterworks</span>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    name: "Footer",
    data: () => ({
      links: [
        {text: 'Contact', link: "/contact"},
        {text: "About Us", link: "https://m.works"},
        {text: "Client Login", link: "https://beta.m.works/client"},
        {text: 'Website Policies and Notices', link: "/website-policies-and-notices"},
        {text: 'Research Policies and Notices', link: "/research-policies-and-notices"},
      ],
    }),
  }
</script>